import request from '@/utils/request'

// 查询列表
export function apiScpMrpSrAssignmentsList (data) {
  return request({
    url: '/scp/scpMrpSrAssignments/list',
    method: 'post',
    data: data
  })
}

// 物料类别
export function apiScpMrpCategoryCodeCategoryBox (query) {
  return request({
    url: '/scp/scpMrpCategoryCode/categoryBox',
    method: 'get',
    params: query
  })
}
